import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { connect, useDispatch } from 'react-redux';

import ErrorContainer from 'Containers/ErrorContainer';

import consultationCategoryProp from 'PropTypes/consultationProps';

import ConsultationLoading from '../Scenes/ConsultationLoading';
import { GeoAggressors } from '../Scenes/GeoAggressors';

import * as consultationSelectors from 'dux/consultation/selectors';
import { fetchAggressors } from 'dux/consultation/thunks';

export const GeoAggressorsComponent = ({
  aggressors,
  consultationCategory,
  error,
  onNext,
  status,
  ...props
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (['idle', 'invalidated'].includes(status)) {
      dispatch(fetchAggressors());
    }
  }, [status, fetchAggressors]);

  switch (status) {
    case 'loading':
    case 'idle':
    case 'invalidated':
      return <ConsultationLoading />;
    case 'success':
      return (
        <GeoAggressors
          {...props}
          aggressors={aggressors}
          consultationCategory={consultationCategory}
          onNext={onNext}
        />
      );
    case 'error':
    default:
      return (
        <ErrorContainer
          error={error}
          retry={() => dispatch(fetchAggressors())}
          sentryMessage="Invalid state on GeoAggressorsContainer"
        />
      );
  }
};

GeoAggressorsComponent.propTypes = {
  aggressors: PropTypes.object,
  consultationCategory: consultationCategoryProp.isRequired,
  error: PropTypes.object,
  onNext: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
};

export default connect(
  (state, { consultationCategory, consultationSubsetCategory, questionIndex, routeParams }) => ({
    ...consultationSelectors.getConsultationQuestionForIndex(state, {
      consultationCategory,
      consultationSubsetCategory,
      questionIndex,
      routeParams,
    }),
    aggressors: consultationSelectors.getAggressorsData(state),
    error: consultationSelectors.getAggressorsError(state),
    status: consultationSelectors.getAggressorsStatus(state),
  })
)(GeoAggressorsComponent);
